import React from "react";

export function mapChildrenIndexedByType(
  children,
  childHandler,
  recursive = false,
  childTypeCounters = {}
) {
  return React.Children.map(children, (child) => {
    if (!child || !child.type) return child;
    const childName =
      child.type.displayName ||
      child.type.name ||
      (typeof child.type === "string" ? child.type : "Component");
    const childIndex = childTypeCounters[childName] || 0;
    // eslint-disable-next-line no-param-reassign
    childTypeCounters[childName] = childIndex + 1;
    if (recursive && child.props.children) {
      const newChildren = mapChildrenIndexedByType(
        child.props.children,
        childHandler,
        recursive,
        childTypeCounters
      );
      return childHandler(
        React.cloneElement(child, {}, newChildren),
        childIndex,
        childName
      );
    }
    return childHandler(child, childIndex, childName);
  });
}
